import { CellTable } from "@/atoms"
import { getDefaultColumnParams } from "@/helpers/table.helpers"
import { MoreTableCell } from "@/molecules/MoreTableCell"
import { AgentCell } from "@/pages/GovernancePage/components/pages/AiPoliciesPage/components/AgentCell"
import { ActionsRuleCard } from "../RuleCard/ActionsRuleCard"
import { WhatBrokenCell } from "./WhatBrokenCell"

export const getCommonColumnsTable = () => {
  return [
    {
      title: "Agent",
      render: AgentCell,
      ...getDefaultColumnParams("name")
    },
    {
      title: "Environment",
      width: 150,
      render: CellTable,
      ...getDefaultColumnParams("environment")
    },
    {
      title: "Applications",
      width: 150,
      render: MoreTableCell,
      ...getDefaultColumnParams("apps")
    },
    {
      title: "Violations",
      width: 105,
      align: "center",
      render: CellTable,
      ...getDefaultColumnParams("violations")
    },
    {
      title: "Last Violation",
      width: 150,
      render: CellTable,
      ...getDefaultColumnParams("lastViolation")
    }
  ]
}

export const getColumnsTableAgent = () => {
  return [
    {
      title: "Timestamp",
      width: 150,
      render: CellTable,
      ...getDefaultColumnParams("timestamp")
    },
    {
      title: "What broke the Rule",
      render: WhatBrokenCell,
      ...getDefaultColumnParams("rule")
    },
    {
      title: "Action taken",
      width: 200,
      render: (_: unknown, record: any) =>
        ActionsRuleCard({ actions: { enabled: true, ...record.actions } }),
      ...getDefaultColumnParams("actions")
    }
  ]
}
